import Vue from 'vue'
import VueRouter from 'vue-router'
import FirstTimeLogin from '../components/login/FirstTimeLogin.vue'
import Login from '../components/login/Login.vue'
import CadConfigurations from '../components/cad/CadConfigurations'
import CreateCadConfiguration from '../components/cad/CreateCadConfiguration'
import EditCadConfiguration from "../components/cad/EditCadConfiguration";

import Users from '../components/user/Users'
import CreateUser from '../components/user/CreateUser'
import User from '../components/user/User'
import EditUser from '../components/user/EditUser'
import EditUserFirstAlert from '../components/user/EditUserFirstAlert'
import EditUserRoles from '../components/user/EditUserRoles'
import EditUserOrganizations from '../components/user/EditUserOrganizations'

import SpreadsheetUpload from '../views/organizations/SpreadsheetUpload'

import Organizations from '../components/organization/Organizations'
import Organization from '../components/organization/Organization'
import CreateOrganization from '../components/organization/CreateOrganization'
import OrganizationDetails from '../components/organization/OrganizationDetails'
import OrganizationPremises from '../components/organization/OrganizationPremises'
import OrganizationApplications from '../components/organization/OrganizationApplications'
import OrganizationFirstAlert from '../components/organization/OrganizationFirstAlert'

import UserProfile from '../components/userProfile/UserProfile'
import UserProfileDetails from '../components/userProfile/UserProfileDetails'

import AddPremise from '../components/premise/AddPremise'
import Premise from '../components/premise/Premise'
import PremiseProfiles from '../components/premise/PremiseProfiles'
import AddProfile from '../components/profile/AddProfile'
import Profile from '../components/profile/Profile'
import OrganizationContactLists from "@/components/organization/contacts/OrganizationContactLists";
import OrganizationIncidents from "@/components/organization/OrganizationIncidents";

import IncidentCommunications from "@/views/IncidentCommunications";
import ViewIncidentCommunications from "@/views/ViewIncidentCommunications";
import LandingPage from "@/views/LandingPage";
import PremiseCommunications from "@/views/premises/PremiseCommunications";

Vue.use(VueRouter)


const routes = [
  {
    path:'/login',
    name:'Login',
    component:Login
  },
  {
    path:'/ft',
    name:'FirstTimeLogin',
    component:FirstTimeLogin
  },
  {
    path: '/home',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../components/Home.vue')
    }
  },
  {
    path: '/',
    name: 'Main',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../components/Main.vue')
    },
    children : [
      {
        path:'',
        name:'LandingPage',
        component:LandingPage/*,
        beforeEnter:((to,from,next) => {
            console.log(router.app.$permissionHolder);
            alert(router.app.$permissionHolder.hasPermission('FIRST_ALERT.VIEW_INCIDENTS'));
            next(router.app.$permissionHolder.hasPermission('FIRST_ALERT.VIEW_INCIDENTS'));
        })*/
      },
      {
        path: 'user-profile',
        name: 'UserProfile',
        component : UserProfile,
        alias:'/user-profile',
        children: [{
          path:'',
          name:'UserProfileDetails',
          component:UserProfileDetails
        }]
      },
      {
        path: 'premise-communications',
        name:'PremiseCommunications',
        component: PremiseCommunications,
        alias:'/premise-communications'
      },
      {
        path: 'cad',
        name:'CadConfigurations',
        component: CadConfigurations,
        alias:'/cad'
      },
      {
        path: 'cad/create',
        name:'CreateCadConfiguration',
        component: CreateCadConfiguration,
        alias:'/cad/create'
      },
      {
        path: 'cad/:configId',
        name: 'EditCadConfiguration',
        component : EditCadConfiguration,
        alias:'/cad/:configId'
      },
      {
        path: 'user',
        name: 'Users',
        component : Users,
        alias:'/user'
      },
      {
        path: 'user/:userId',
        name: 'User',
        component : User,
        alias:'/user/:userId',
        children: [{
          path:'',
          component:EditUser
        },{
          path:'first-alert',
          name:'EditUserFirstAlert',
          component : EditUserFirstAlert
        },{
          path:'roles',
          name:'EditUserRoles',
          component : EditUserRoles
        },{
          path:'organizations',
          name:'EditUserOrganizations',
          component : EditUserOrganizations
        }]
      },
      {
        path: 'user/create',
        name: 'CreateUser',
        component : CreateUser,
        alias:'/user/create'
      },
      {
        path: 'organization',
        name: 'Organizations',
        component : Organizations,
        alias:'/organization'
      },
      {
        path: 'organization/create',
        name: 'CreateOrganization',
        component : CreateOrganization,
        alias: '/organization/create',
      },
      {
        path: 'organization/:organizationId',
        name: 'Organization',
        component : Organization,
        alias:'/organization/:organizationId',
        children: [{
          path:'',
          component:OrganizationDetails
        },{
          path:'premise',
          component:OrganizationPremises
        },{
          path:'first-alert',
          component:OrganizationFirstAlert
        },{
          path:'applications',
          component:OrganizationApplications
        },{
          path:'contact-lists',
          component:OrganizationContactLists
        },{
		  path: 'spreadsheet',
		  component : SpreadsheetUpload
	  	}]
      },
      {
        path: 'organization/:organizationId/incident',
        name: 'OrganizationIncidents',
        component : OrganizationIncidents,
        alias:'/organization/:organizationId/incident'
      },
      {
        path: 'incident/:cadRequestId',
        component: IncidentCommunications
      },
      {
        path: 'incident-view/:cadRequestId',
        component: ViewIncidentCommunications
      },
      {
        path:'premise/create',
        name:'CreatePremise',
        component:AddPremise,
        props:true,
        alias:'/premise/create'
      },{
        path:'premise/:premiseId',
        name:'Premise',
        component:Premise,
        alias:'/premise/:premiseId',
        children: [
          {
            path:'profile',
            component:PremiseProfiles
          }
        ]
      },
      {
        path:'profile/create',
        name:'CreateProfile',
        component:AddProfile,
        props:true,
        alias:'/profile/create'
      },{
        path:'profile/:profileId',
        name:'Profile',
        component:Profile,
        alias:'/profile/:profileId'
      },
    ]
  }
]

const router = new VueRouter({
  routes
});
/*
router.beforeEach((to,from,next) => {

  //const whitelists = ['/request-reset','/login']

  next();
});*/

export default router;
